<template>
  <div title="Get ready to meet your ideal agent">
    <div class="row">
      <div class="col verbiage">
        <h3 class="bold">Thank you!</h3>
      </div>
    </div>
    <div class="row verbiage">
      <div class="col">
        <h4 class="fw-400 pt-4">We will get in touch with you shortly.</h4>
      </div>
    </div>
    <div class="row verbiage">
      <div class="col">
        <h4>In the meantime, check out our 5-star reviews on <a
            href="https://www.trustpilot.com/review/idealagent.com" target="_blank">Trust Pilot</a> <br/>or
          go back to our <a href="/">home page</a>.</h4>
      </div>
    </div>
    <div class="ad">
      <img src="https://static.idealagent.com/web/banners/ideal-agent_display_ad_2.png"/>
    </div>
  </div>
</template>

<script>
import {saveMarketing, getConversionHtmlPage} from "@/services/apiService";

export default {
  name: "YourAgent",
  props: ['source'],
  data() {
    return {marketing: null}
  },
  methods: {
    populateMarketing: function (value) {
      this.marketing = value;
      saveMarketing('Lead_Source', this.marketing);
    }
  },
  computed: {
    marketingPopulated: function () {
      return !this.isEmpty(this.marketing);
    }
  },
  async mounted() {
    let source = this.source;

    let response = await getConversionHtmlPage(source);
    let htmlSource = response ? response.data : false;

    if (htmlSource) {
      let iframe = document.createElement('iframe');
      iframe.style.display = "none";
      document.body.appendChild(iframe);
      let doc = iframe.contentWindow.document;
      doc.open();
      doc.write(htmlSource);
      doc.close();
    }

    // if (source.toLowerCase().includes("rdr")) {
    //     let script = document.createElement('script');
    //     script.setAttribute('src', 'https://www.rgfj1trk.com/scripts/sdk/everflow.js');
    //     script.setAttribute('type', 'text/javascript');
    //     script.async = true;
    //     document.head.appendChild(script);
    //
    //     script.onload = function () {
    //         // eslint-disable-next-line no-undef
    //         EF.conversion({
    //             offer_id: 21,
    //         });
    //     };
    //
    //     let script2 = document.createElement('script');
    //     script2.setAttribute('type', 'text/javascript');
    //     script2.async = true;
    //     script2.text = '!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version=\'2.0\';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,\'script\',\'https://connect.facebook.net/en_US/fbevents.js\');fbq(\'init\', \'258374985302819\');fbq(\'track\', \'Purchase\', {currency: "USD", value: 75.00});';
    //     document.head.appendChild(script2);
    //
    //     let iframe = document.createElement('iframe');
    //     iframe.style.display = "none";
    //     iframe.src = "https://www.rgfj1trk.com/?nid=443&oid=21&transaction_id=TRANSACTION_ID";
    //     document.body.appendChild(iframe);
    //
    // }
    //
    // if (source === Sources.AD_FUEL) {
    //     let script = document.createElement('script');
    //     script.setAttribute('type', 'text/javascript');
    //     script.async = true;
    //     script.text = '!function(a,e,d,m,t){a.adm={};a.adm.pixid=147507;var o=e.getElementsByTagName("head")[0],c=e.createElement("script");a.adm.json="https://ps.l.a8723.com/e91cedab-ec8d-4072-b2f1-cc81366f650d.json",a.adm.pixurl="https://pool.a8723.com",c.src="https://pj.l.a8723.com/admtracker.lib.min.js",c.async=!0,o.appendChild(c)}(window,document);';
    //     document.head.appendChild(script);
    //
    //     let img = document.createElement("img");
    //     img.src = "https://pool.a8723.com/pixel?id=147507&t=img";
    //     img.width = 1;
    //     img.height = 1;
    //     document.body.appendChild(img);
    // }
  }
}
</script>

<style scoped>
.verbiage {
  margin-bottom: 1em;
}

.button-row {
  margin: auto;
  left: 0;
  right: 0;
  padding: 10px;
}

.button {
  margin: auto;
  left: 0;
  right: 0;
  padding: 10px;
  margin: 10px;
  width: 175px;
}

.headline {
  font-size: 1.5em;
  text-align: left;
}

.ad {
  text-align: center;
  padding-top: 50px;
  margin: 0 auto;
}
.ad img {
  width: 100%;
  max-width: 800px;
}
</style>
